import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-state-admin',
  templateUrl: './empty-state-admin.component.html',
  styleUrls: ['./empty-state-admin.component.scss']
})
export class EmptyStateAdminComponent {

}
